import DataTableCell_vue_vue_type_script_setup_true_lang_default from "./DataTableCell.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/components/data-table/DataTableCell.vue
var DataTableCell_default = DataTableCell_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { DataTableCell_default as default };

//# sourceMappingURL=DataTableCell.vue.js.map